import { css } from '@emotion/react';

export const redirecterCss = (theme) => css`
  color: ${theme.color.surveyText};
  text-align: center;
`;
